module.exports = __webpack_public_path__ + "img/empty.7ae9d1a2.png";